// extracted by css-extract-rspack-plugin
export default {"cls1":"LanguageDropdown-cls1_0NP","cls2":"LanguageDropdown-cls2_bPh LanguageDropdown-cls1_0NP"};